import React from 'react';

import CTCAccountCon from "./../../../Components/Common/CTCAccount";

import translate from "./../../../lib/translate/TranslateJs";


function CTCAccount(props) {
    return (
        <CTCAccountCon
            {...props}
            CTCRadio={(propCon) => (
                <div className="ctc-card-container">
                    {
                        // 排列順序BA確認需為USDT-ERC20 => USDT-TRC20
                        propCon.bankAccounts.sort((a,b)=>a.name.localeCompare(b.name)).map((v, i) => (
                            <div
                                key={"ctc_account_" + i}
                                className={`ctc-card ${propCon.currValue === v.code ? "active" : ""}`}
                                onClick={() => {propCon.onSelectChange(v.code)}}
                            >
                                {/* <img /> */}
                                <div className={`${v.code}`} />
                                <div className="name">{v.name}</div>
                                <div>{`(${v.code})`}</div>
                            </div>
                        ))
                    }
                </div>
            )}
        />
    );
}


export default CTCAccount;

